<template>
  <div class="d-flex align-items-center">
    <div
      v-for="(user, index) in users"
      :key="index"
      class="article__analyst mr-1"
    >
      <div
        v-if="user.picture_url !== 'null' && user.picture_url !== null"
        v-tooltip.top="user.name"
        :style="`background-image: url(${user.picture_url});`"
        class="rounded-circle img-circle-bg border-white article__analyst__img"
      />
      <div
        v-else
        v-tooltip.top="user.name"
        class="rounded-circle img-circle-name border-white article__analyst__img"
      >
        {{ getInitials(user.name) }}
      </div>
      <div
        v-if="user.name === $login.getUser().name"
        v-tooltip.top="'Current User'"
        class="rounded-circle img-circle-current-user border-white article__analyst__img"
      />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      currentPath: null,
      users: [],
    }
  },

  beforeDestroy () {
    this.$echo.leave(`admin.presence.${this.currentPath}`)
  },

  mounted () {
    let val = this.$route.path
    val = val.replace(/\//g, '-')
    this.currentPath = val
    this.$echo.join(`admin.presence.${val}`)
        .here((users) => {
          this.users = users
        })
        .joining((user) => {
          this.users.push(user)
        })
        .leaving((user) => {
          this.users.splice(this.users.indexOf(user))
        })
  },
  methods: {
    getInitials (name = '') {
      return name.split(' ')
          .reduce((acc, word) =>
            `${acc}${word.slice(0, 1)}`, ''
          )
    },
  },

}
</script>

<style lang="scss">
.img-circle-bg {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
  width: 100%;
}

.img-circle-name {
  background-color: $primary;
  color: white;
  height: 100%;
  width: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 10px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1px;
}

.img-circle-current-user{
  position: absolute;
  top: 0;
  border: 2px solid #fff;
  right: 0;
  height: 8px;
  width: 8px;
  background-color: #00cc79;
}

.article__analyst {
  position: relative;
  height: 2rem;
  width: 2rem;
  &__img {
  }
}
</style>

